import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { useNotification } from '../../contexts/NotificationContext';
import { useUserForm } from './shared/hooks/useUserForm';
import { useUser } from './shared/services/useUserService';
import UserForm from './shared/sections/UserForm';
import FormPageLayout from '../../components/FormPageLayout';

const UserPage = () => {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { showNotification } = useNotification();
  const [submitting, setSubmitting] = useState(false);

  const { isEdit, roles, loading, existingData, submit } = useUser(user_id);
  const { formData, errors, setInitialData, handleNameChange, handleChange, handleBlur, validate, buildAddPayload, buildEditPayload } = useUserForm(undefined, isEdit);

  useEffect(() => { if (existingData) setInitialData(existingData); }, [existingData, setInitialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      const payload = isEdit ? buildEditPayload() : buildAddPayload();
      const res = await submit(payload);
      if (res.data.status === 'success') {
        showNotification('success', isEdit ? `User info updated for ${formData.fullname}!` : `User "${formData.fullname}" added successfully!`);
        
        const returnPage = location.state?.page || 0;
        const returnMenu = location.state?.activeMenu || 'User List';
        
        setTimeout(() => {
          navigate(`/home?page=${returnPage}`, { 
            state: { activeMenu: returnMenu } 
          });
        }, 1000);
      } else {
        showNotification('error', res.data.message || 'An error occurred.');
      }
    } catch (err) {
      console.error('User submission error:', err);
      const message = err.response?.data?.error || err.response?.data?.message || err.message || 'Server error.';
      showNotification('error', message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FormPageLayout 
      title={isEdit ? 'Edit User' : 'ADD NEW USER'} 
      backTo={{ 
        path: `/home?page=${location.state?.page || 0}`, 
        state: { activeMenu: location.state?.activeMenu || 'User List' } 
      }} 
      loading={loading}
    >
      <form onSubmit={handleSubmit}>
        <UserForm formData={formData} errors={errors} roles={roles} handleNameChange={handleNameChange} handleChange={handleChange} handleBlur={handleBlur} isEdit={isEdit} />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={submitting}>
          {submitting ? (isEdit ? 'Updating...' : 'Adding User...') : (isEdit ? 'Update User' : 'Add User')}
        </Button>
      </form>
    </FormPageLayout>
  );
};

export default UserPage;
